<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ornament"><img alt="" src="image/orn_top.jpg"/></p>
<p class="PN" id="_idParaDest-3"><span class="FinaHyphen"><a id="page_vi"></a><a id="page_1"></a></span><a id="page_1"><span class="FinaHyphen">-</span> PART ONE <span class="FinaHyphen">-</span></a></p><a id="page_1">
<p class="PTb">Wickam Farm,</p>
<p class="PT">Oxfordshire</p>
<p class="ornament2"><img alt="" src="image/orn_bottom.jpg"/></p>
</a></div><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?7c485e06